import "./invoice-export-bar.styles.scss";
import { useContext } from "react";
import ProgressBar from "../progress-bar/progress-bar.component";
import Button from "../button/button.component";
import { InvoicesContext } from "../../contexts/invoices.context";

const InvoiceExportBar = ({ selectedIds = [] }) => {
  const { exportJob, startInvoiceExport, downloadExportResult, resetExportJob } =
    useContext(InvoicesContext);

  const handleExport = async () => {
    await startInvoiceExport(selectedIds);
  };

  if (!exportJob) {
    return (
      <div className="invoice-export-bar">
        <Button
          label={`Export ${selectedIds.length} Selected as PDF`}
          onClick={handleExport}
          disabled={selectedIds.length === 0}
        />
      </div>
    );
  }

  if (exportJob.status === "failed") {
    return (
      <div className="invoice-export-bar">
        <span className="export-error">
          Export failed{exportJob.error ? `: ${exportJob.error}` : ""}
        </span>
        <Button label="Dismiss" variant="invoice-export-bar-secondary" onClick={resetExportJob} />
      </div>
    );
  }

  if (exportJob.status === "completed") {
    return (
      <div className="invoice-export-bar">
        <span className="export-summary">
          Export ready ({exportJob.total} invoice
          {exportJob.total === 1 ? "" : "s"}) — download started automatically
        </span>
        <Button
          label="Download Again"
          onClick={() => downloadExportResult()}
        />
        <Button
          label="Start New Export"
          variant="invoice-export-bar-secondary"
          onClick={resetExportJob}
        />
      </div>
    );
  }

  const percent = exportJob.total
    ? Math.round((exportJob.processed / exportJob.total) * 100)
    : 0;

  return (
    <div className="invoice-export-bar">
      <span className="export-progress-label">
        Generating PDF… {exportJob.processed} / {exportJob.total} ({percent}%)
      </span>
      <ProgressBar progress={percent} />
    </div>
  );
};

export default InvoiceExportBar;
